import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ActionLink } from 'components/shared';

const DropDownItemContainer = styled.li`
  white-space: nowrap;
  transition: all cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.2s;
  display: flex;
  align-items: center;
  padding: var(--cc_size_spacing_s);
  margin: 0;
  border-radius: var(--cc_size_border_radius_l);
  color: var(--cc_color_link_secondary);
  font-family: 'Averta', system-ui, sans-serif;
  font-weight: 400;
  font-size: var(--cc_size_text_s);
  cursor: pointer;

  :hover {
    background: var(--cc_color_button_background_subtle);
  }
`;

const DropDownLink = styled(ActionLink)`
  display: flex;
  align-items: center;
  color: inherit;
`;

const NOOP = () => {};

const CardMenuItem = ({ children, onClick = NOOP, href = '', target }) => {
  if (href.length) {
    return (
      <DropDownItemContainer>
        <DropDownLink href={href} target={target}>
          {children}
        </DropDownLink>
      </DropDownItemContainer>
    );
  } else {
    return (
      <DropDownItemContainer onClick={onClick}>
        {children}
      </DropDownItemContainer>
    );
  }
};

CardMenuItem.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
};

export default CardMenuItem;
